import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import PropTypes from 'prop-types';
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import withRouter from '../../../shared/utils/WithRouter'

const styles = theme => ({
	overlayStyle: {
		// sets the opacity of the background color
		backgroundColor: theme.palette.action.active,
		position: 'absolute',
		bottom: '0',
		right: '0',
		left: '0',
		padding: '0.1em 0.3em 0.2em',
		display: 'block',
	},

	titleStyle: {
		color: theme.palette.getContrastText(theme.palette.action.active),
		opacity: 0.87,
		display: 'block',
		fontSize: '1.20em',
		lineHeight: '1.5em',
		marginRight: '10px',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
		width: '100%',
		transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',

		[theme.breakpoints.down('xs')]: {
			fontSize: '0.75em',
		},

		[theme.breakpoints.up('sm')]: {
			fontSize: '0.85em',
		},

		[theme.breakpoints.up('md')]: {
			fontSize: '1em',
		},

		[theme.breakpoints.up('lg')]: {
			fontSize: '1.1em',
		},

		[theme.breakpoints.up('xl')]: {
			fontSize: '1.2em',
		},
	},

	productCardStyle: {
		position: 'relative',
		height: '100%',
	},

	cardMediaStyle: {
		height: '100%',
	},

	/* Generic item display card for category and subcategory */
	itemContainer: {
		cursor: 'pointer',
		height: '100%',
		boxShadow: '0 2px 6px rgba(0,0,0,.4)',
	},
});

/**
 * Display a category as a card.
 */
const CategoryCard = (props) => {
	/**
	 * Navigate to the correct sub category page.
	 */
	const handleNavigation = categoryId => {
		props.router.navigate(`/category/${categoryId}`);
		//history.go(`/category/${categoryId}`);
	};

	const { cat, id, pictureUrl, classes } = props;

	return (
		<div className={classes.itemContainer}>
			<Card onClick={() => handleNavigation(id)} className={classes.productCardStyle}>
				<CardMedia className={classes.cardMediaStyle} image={pictureUrl}>
					<CardHeader
						title={<span className={classes.titleStyle}>{cat}</span>}
						className={classes.overlayStyle}
					/>
				</CardMedia>
			</Card>
		</div>
	);
}

CategoryCard.propTypes = {
	id: PropTypes.number.isRequired,
	cat: PropTypes.string.isRequired,
	pictureUrl: PropTypes.string,
	classes: PropTypes.shape({
		overlayStyle: PropTypes.string,
		titleStyle: PropTypes.string,
		productCardStyle: PropTypes.string,
		cardMediaStyle: PropTypes.string,
		itemContainer: PropTypes.string,
	}).isRequired,
};

CategoryCard.defaultProps = {
	pictureUrl: '',
};

export default withRouter(withStyles(styles, { name: 'CategoryCard' })(CategoryCard));
